
export default {
  data() {
    return {
      title: "Refund Policy | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
};
